import { config } from "@lisapet/config";
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./supabaseTypes";

const supabaseUrl = config.supabase.url;
const supabaseKey = config.supabase.apiKey;
const supabase = createClient<Database>(supabaseUrl as string, supabaseKey as string);

export { supabase };
